import { render, staticRenderFns } from "./ShapeRight.vue?vue&type=template&id=c30b16ac"
import script from "./ShapeRight.vue?vue&type=script&lang=js"
export * from "./ShapeRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports